import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";

import ProductsWidget from "features/admin/Products";
import DashboardWidget from "features/admin/Dashboard";
import EditProduct from "features/admin/Products/actions/EditProduct";
import AddProduct from "features/admin/Products/actions/AddProduct";
import AddTag from "features/admin/Tags/actions/AddTag";
import TagsWidget from "features/admin/Tags/TagsWidget";
import BannersWidget from "features/admin/Banners/BannersWidget";
import EditTag from "features/admin/Tags/actions/EditTag";
import AddBanner from "features/admin/Banners/actions/AddBanner";
import EmailSender from "features/admin/EmailSender/EmailSender";
import EditBanner from "features/admin/Banners/actions/EditBanner";
import OrdersWidget from "features/admin/Orders/OrdersWidget";
import MetasWidget from "features/admin/Meta/MetaWidget";
import AddMeta from "features/admin/Meta/AddMeta";
import EditMeta from "features/admin/Meta/EditMeta";
import AddOrder from "features/admin/Orders/actions/AddOrder";
import VideosWidget from "features/admin/Videos/VideosWidget";
import AddVideo from "features/admin/Videos/actions/AddVideo";
import EditVideo from "features/admin/Videos/actions/EditVideo";
import GalleryWidget from "features/admin/Gallery";
import AddGalleryItem from "features/admin/Gallery/components/AddGalleryItem";
import EditGalleryItem from "features/admin/Gallery/components/EditGalleryItem";
import PromoWidget from "features/admin/Promotion/PromoWidget";
import AddPromo from "features/admin/Promotion/actions/AddPromo";
import EditPromo from "features/admin/Promotion/actions/EditPromo";
import AddInstallation from "features/admin/Installations/actions/AddInstallation";
import EditInstallation from "features/admin/Installations/actions/EditInstallation";
import InstallationWidget from "features/admin/Installations/InstallationWidget";
import AccessoriesWidget from "features/admin/Accessories/AccessoriesWidget";
import AddAccessory from "features/admin/Accessories/actions/AddAccessory";
import EditAccessory from "features/admin/Accessories/actions/EditAccessory";
import EditOrder from "features/admin/Orders/actions/EditOrder";
import AddComment from "features/admin/Comments/AddComment";
import CommentsWidget from "features/admin/Comments/CommentsWidget";
import EditComment from "features/admin/Comments/EditComment";

const AdminRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardWidget />} />
      <Route path="products" element={<ProductsWidget />} />
      <Route path="products/edit/:id" element={<EditProduct />} />
      <Route path="products/add" element={<AddProduct />} />
      {/* <Route path="multisplit/edit/:id" element={<EditProduct />} />
      <Route path="multisplit/add" element={<AddProduct />} /> */}
      <Route path="tags" element={<TagsWidget />} />
      <Route path="tags/add" element={<AddTag />} />
      <Route path="tags/edit/:id" element={<EditTag />} />
      <Route path="banners" element={<BannersWidget />} />
      <Route path="banners/add" element={<AddBanner />} />
      <Route path="banners/edit/:id" element={<EditBanner />} />
      <Route path="email-sender" element={<EmailSender />} />
      <Route path="orders" element={<OrdersWidget />} />
      <Route path="orders/add" element={<AddOrder />} />
      <Route path="orders/edit/:id" element={<EditOrder />} />
      <Route path="metas" element={<MetasWidget />} />
      <Route path="metas/add" element={<AddMeta />} />
      <Route path="metas/edit/:id" element={<EditMeta />} />
      <Route path="comments" element={<CommentsWidget />} />
      <Route path="comments/add" element={<AddComment />} />
      <Route path="comments/edit/:id" element={<EditComment />} />
      <Route path="videos" element={<VideosWidget />} />
      <Route path="videos/add" element={<AddVideo />} />
      <Route path="videos/edit/:id" element={<EditVideo />} />
      <Route path="gallery" element={<GalleryWidget />} />
      <Route path="gallery/add" element={<AddGalleryItem />} />
      <Route path="gallery/edit/:id" element={<EditGalleryItem />} />
      <Route path="promotions" element={<PromoWidget />} />
      <Route path="promotions/add" element={<AddPromo />} />
      <Route path="promotions/edit/:id" element={<EditPromo />} />
      <Route path="installations" element={<InstallationWidget />} />
      <Route path="installations/add" element={<AddInstallation />} />
      <Route path="installations/edit/:id" element={<EditInstallation />} />
      <Route path="accessories" element={<AccessoriesWidget />} />
      <Route path="accessories/add" element={<AddAccessory />} />
      <Route path="accessories/edit/:id" element={<EditAccessory />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default AdminRouter;
